"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfOldListLevelInfoCollection = void 0;
var rtf_old_list_level_info_1 = require("./rtf-old-list-level-info");
var RtfOldListLevelInfoCollection = (function () {
    function RtfOldListLevelInfoCollection() {
        this.listLevelInfo = [];
    }
    RtfOldListLevelInfoCollection.prototype.getByIndex = function (index) {
        if (this.listLevelInfo.length <= index)
            this.ensureLevelIndex(index);
        return this.listLevelInfo[index];
    };
    RtfOldListLevelInfoCollection.prototype.ensureLevelIndex = function (index) {
        var count = this.listLevelInfo.length;
        for (var i = count; i <= index; i++) {
            this.listLevelInfo.push(new rtf_old_list_level_info_1.RtfOldListLevelInfo());
        }
    };
    return RtfOldListLevelInfoCollection;
}());
exports.RtfOldListLevelInfoCollection = RtfOldListLevelInfoCollection;
